import { SidebarItem, SidebarItemType } from '@siemens/component-lib';
import { UserRole } from '../../app/shared/enums/UserRole.enum';

export const sidebarItems: SidebarItem[] = [
    {
        routerLink: '/home',
        tooltip: 'sidebar.home',
        icon: 'apps',
        name: 'sidebar.home',
        type: SidebarItemType.LINK
    },
    {
        tooltip: 'sidebar.create-new-workflow',
        icon: 'plus-large',
        name: 'sidebar.create-new-workflow',
        ariaLabel: 'sidebar.create-new-workflow',
        roles: [
            UserRole.ADMIN,
            UserRole.PRODUCT_LIFECYCLE_MANAGER,
            UserRole.LOGISTICS,
            UserRole.EXPORT_CLASSIFICATION,
            UserRole.CUSTOMS
        ],
        type: SidebarItemType.BUTTON
    },
    {
        routerLink: '/workflows',
        tooltip: 'sidebar.all-workflows',
        icon: 'browse-all',
        name: 'sidebar.all-workflows',
        roles: [UserRole.ADMIN],
        type: SidebarItemType.LINK
    },
    {
        routerLink: '/admin',
        tooltip: 'sidebar.admin',
        icon: 'monitor',
        name: 'sidebar.admin',
        roles: [UserRole.ADMIN],
        type: SidebarItemType.LINK
    }
];

export const bottomSidebarItems: SidebarItem[] = [
    {
        routerLink: 'https://siemens.com/support',
        tooltip: 'sidebar.support',
        icon: 'help',
        name: 'sidebar.support',
        type: SidebarItemType.LINK
    }
];
